import getConditionChildrenKey from 'editor/src/store/design/reducer/getConditionChildrenKey';
import { RootState } from 'editor/src/store/index';

export interface ConditionImportImpact {
  /** Elements currently linked to one of this condition's options. */
  linkedElementsCount: number;
  /** Sub-conditions parented to one of this condition's options. */
  subConditionsCount: number;
  /** Texts on this condition whose own (non-label) values would be cleared. */
  customTextCount: number;
}

/**
 * What importing a file into an EXISTING condition would unlink, so the menu
 * can decide whether to ask for confirmation and what to say. `undefined` when
 * the condition can't be found (caller should treat that as "nothing to ask").
 */
const getConditionImportImpact = (
  state: RootState,
  spreadIndex: number,
  conditionId: string,
): ConditionImportImpact | undefined => {
  const conditionGroup = state.design.designData?.spreads[spreadIndex]?.conditionGroup;
  const condition = conditionGroup?.conditions[conditionId];
  if (!conditionGroup || !condition) {
    return undefined;
  }

  let linkedElementsCount = 0;
  let subConditionsCount = 0;
  condition.options.forEach((option) => {
    const children = conditionGroup.children[getConditionChildrenKey(conditionId, option.id)] ?? [];
    children.forEach((child) => {
      if (child.type === 'condition') {
        subConditionsCount += 1;
      } else {
        linkedElementsCount += 1;
      }
    });
  });

  let customTextCount = 0;
  state.design.designData?.spreads.forEach((spread) => {
    spread.pages[0]?.groups.media?.forEach((element) => {
      if (
        element.type === 'text' &&
        element.extra.textVariants?.conditionId === conditionId &&
        !element.extra.textVariants.useOptionLabel
      ) {
        customTextCount += 1;
      }
    });
  });

  return { linkedElementsCount, subConditionsCount, customTextCount };
};

export default getConditionImportImpact;
